import request, { AxiosRequestConfig } from '@hb/sharp-request';
import requestDefault from '@/shared/utils/request';
import { dataURLtoFile } from '@/shared/utils/dataURLtoBlob';
import { newGatewayUrl, isDevEnv } from '@/constant';
import { OssUploadParams } from './types';

export const uploadIdToOss = async (
  base64: string,
  scene: string,
  options?: AxiosRequestConfig,
): Promise<string> => {
  try {
    const params = await requestDefault.postGate<OssUploadParams>('f.oss.policy.user', {
      scene,
    },
    {
      baseURL: newGatewayUrl,
      ...options,
    });
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const result = await request.post(
      // 本地开发环境使用proxy代理至阿里云OSS域名进行图片上传
      isDevEnv ? `${window.location.origin}/ossUpload` : params.host,
      {
        ...params,
        file: dataURLtoFile(base64),
      },
      {
        timeout: 0,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        transformRequest(data) {
          const formData = new FormData();

          Object.keys(data).forEach((key) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            formData.append(key, data[key]);
          });

          return formData;
        },
        ...options,
      },
    );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return result.url as string;
  } catch (error) {
    throw new Error('图片上传失败!');
  }
};

export const reSizeImg = (
  base64: string,
  maxWidth = 500,
  maxHeight = 500,
): Promise<string> => new Promise((resolve, reject) => {
  const img: HTMLImageElement = new Image();

  img.onload = function onImageLoaded() {
    try {
      // 图片原始尺寸
      const originWidth = (this as HTMLImageElement).width;
      const originHeight = (this as HTMLImageElement).height;

      // 目标尺寸
      let targetWidth = originWidth;
      let targetHeight = originHeight;
      // 图片尺寸超过400x400的限制
      if (originWidth > maxWidth || originHeight > maxHeight) {
        if (originWidth / originHeight > maxWidth / maxHeight) {
          // 更宽，按照宽度限定尺寸
          targetWidth = maxWidth;
          targetHeight = Math.round(maxWidth * (originHeight / originWidth));
        } else {
          targetHeight = maxHeight;
          targetWidth = Math.round(maxHeight * (originWidth / originHeight));
        }
      }
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      // canvas对图片进行缩放
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      if (context) {
        // 清除画布
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片压缩
        context.drawImage(
          img,
          0,
          0,
          originWidth,
          originHeight,
          0,
          0,
          targetWidth,
          targetHeight,
        );
        // canvas转为blob并上传
        resolve(canvas.toDataURL());
      } else {
        reject(new Error('图片压缩失败'));
      }
    } catch (e) {
      reject(e);
    }
  };

  img.src = base64;
});

const UploadImg = {
  uploadIdToOss,
  reSizeImg,
};

export default UploadImg;
